import { ArrowLeftIcon } from '~components/icons';
import useLabels from '~hooks/useLabels';
import { CollectionDetailController } from '~modules/media-library/controller/CollectionDetailController';
import useAssetActions from '~modules/media-library/controller/useAssetActions';
import { Button } from '~modules/media-library/view/Button';

export function CollectionHeader() {
  const { idCollection, closeCollection } = useAssetActions();
  const { btnMediaLibraryCloseCollection } = useLabels(['btnMediaLibraryCloseCollection']);

  if (!idCollection) return null;

  return (
    <div className="ml--collection-header bg-white px-3">
      <div className="relative py-3 flex flex-col gap-3 mx-auto max-w-screen-xl">
        <Button onClick={closeCollection} variant="ghost">
          <ArrowLeftIcon className="w-4 h-4 mr-2" />
          {btnMediaLibraryCloseCollection}
        </Button>
        <CollectionDetailController assetId={idCollection} />
      </div>
    </div>
  );
}
